module.exports = __webpack_public_path__ + "img/your.576114b5.svg";